export default __webpack_public_path__ + "0cc433ad533f06be6ebd8d1293a1edd7.png";